/**
 * Base URL do backend. Vazio = mesmo host do site (recomendado com Nginx em /api).
 * Se REACT_APP_BACKEND_URL apontar para o mesmo origin do browser, devolve "" para evitar pedidos desnecessários cross-origin.
 */
export function getBackendBaseUrl() {
  const raw = (
    typeof process !== 'undefined' &&
    process.env &&
    (process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL)
  ) || '';
  const t = String(raw).trim().replace(/\/$/, '');
  const low = t.toLowerCase();
  if (low === 'undefined' || low === 'null') return '';
  if (!t) return '';
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    try {
      const u = t.startsWith('http://') || t.startsWith('https://') ? t : `https://${t}`;
      if (new URL(u).origin === window.location.origin) {
        return '';
      }
    } catch (_) {
      return t;
    }
  }
  return t;
}

export const API_BASE_URL = getBackendBaseUrl();
